module.exports = __webpack_public_path__ + "static/media/TW-AFLDraft-2019-tablet-1476x200.03774e28.jpg";